import { Link } from "react-router-dom";
import { streamers } from "@/mocks/streamers";
import { channels } from "@/mocks/channels";
import SectionHeading from "@/components/base/SectionHeading";

export default function FeaturedStreamers() {
  return (
    <section className="w-full bg-background-100 border-y border-background-200/70">
      <div className="w-full px-4 md:px-8 py-10 md:py-14">
        <SectionHeading
          eyebrow="明星主播"
          icon="ri-star-smile-line"
          title="值得关注的签约主播"
          subtitle="平台签约优质主播，内容稳定更新，互动氛围友好，关注他们不错过每一场直播。"
        />
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {streamers.map((streamer) => {
            const channel = channels.find((item) => item.key === streamer.channel);
            return (
              <div
                key={streamer.id}
                className="rounded-lg border border-background-200/70 bg-background-50 p-5 flex flex-col"
              >
                <div className="flex items-center gap-4">
                  <span className="w-16 h-16 rounded-full overflow-hidden shrink-0 border-2 border-primary-100">
                    <img
                      src={streamer.avatar}
                      alt={streamer.name}
                      title={`${streamer.name} - 主播`}
                      className="w-full h-full object-top object-cover"
                    />
                  </span>
                  <div className="min-w-0">
                    <h3 className="font-heading text-base font-semibold text-foreground-950 truncate">
                      {streamer.name}
                    </h3>
                    <div className="mt-1.5 flex flex-wrap items-center gap-2">
                      <span className="rounded-full bg-accent-100 px-2 py-0.5 text-[11px] font-label font-semibold text-accent-900">
                        {streamer.level}
                      </span>
                      {channel && (
                        <Link
                          to={`/category/${channel.key}`}
                          className="text-[11px] font-label text-secondary-700 hover:text-secondary-900 transition-colors"
                        >
                          {channel.name}
                        </Link>
                      )}
                    </div>
                  </div>
                </div>
                <p className="mt-4 text-sm text-foreground-600 leading-relaxed line-clamp-2">{streamer.bio}</p>
                <div className="mt-4 flex items-center justify-between">
                  <span className="text-xs text-foreground-500 flex items-center gap-1">
                    <i className="ri-user-heart-line text-base text-primary-500" />
                    {streamer.followers} 关注
                  </span>
                  <div className="flex items-center gap-2">
                    {streamer.socials.map((social) => (
                      <span
                        key={social.label}
                        title={social.label}
                        className="w-8 h-8 rounded-md bg-background-100 flex items-center justify-center text-foreground-500 hover:text-primary-600 transition-colors cursor-pointer"
                      >
                        <i className={`${social.icon} text-base`} />
                      </span>
                    ))}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}